import React, { useState } from "react";
import features from '../../config/features';
// import './sections/style.css';

const FeatureRow = ({ feature }) => (
  <tr>
    <td className='ps-5 p-3'>{feature.name}</td>
    <td className='text-center p-3'>
      {feature.basic ? (
        <i className="bi bi-check-circle-fill text-success"></i>
      ) : (
        <i className="bi bi-x-lg text-danger"></i>
      )}
    </td>
    <td className='text-center p-3'>
      {feature.premium ? (
        <i className="bi bi-check-circle-fill text-success"></i>
      ) : (
        <i className="bi bi-x-lg text-danger"></i>
      )}
    </td>
    <td className='text-center p-3'>
      {feature.enterprise ? (
        <i className="bi bi-check-circle-fill text-success"></i>
      ) : (
        <i className="bi bi-x-lg text-danger"></i>
      )}
    </td>
  </tr>
);

const Pricing = () => {
  return (
    <>      
      <div className="container py-5" id="pricing">
        {/* Section Heading */}
        <div className="text-center mb-lg-5 mb-3 fw-semibold display-4">
          Amazing Offers
        </div>

        {/* Pricing Cards */}
        <div className="row justify-content-center">
          <PricingCard />
        </div>

        {/* Spacer */}
        <div className="py-5"/>

        {/* Subheading */}
        <div className="text-center d-flex flex-column justify-content-center align-items-center">
          <h2 className="h2">Choose Your Perfect Plan</h2>
          <p className="fs-6 mb-5 text-center col-lg-4 col-md-6 col-10">
            Tailored Solutions for Every Business – Flexible Monthly and Yearly Options
          </p>   
        </div>      

        {/* Feature Table */}
        <div className="table-responsive">
          <table className="table table-striped text-start rounded-3">
            <thead className="table-dark">            
              <tr>
                <th className='ps-3 ps-md-5 p-3'>Features</th>
                <th className='text-center table-header p-3'>Basic</th>
                <th className='text-center table-header p-3'>Premium</th>
                <th className='text-center table-header p-3'>Enterprise</th>
              </tr>
            </thead>
            <tbody>
              {features.map((feature, index) => (
                <FeatureRow key={index} feature={feature} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>    
  );
};

export default Pricing;


const PricingCard = () => {
  // State to keep track of the selected pricing type
  const [isMonthly, setIsMonthly] = useState(true);
  const [fade, setFade] = useState(false);

  // Array of pricing plans
  const plans = [
    { name: "Basic", monthlyPrice: "1603", off: "20" },
    { name: "Premium", monthlyPrice: "13416", off: "30" },
    // { name: "Enterprise", monthlyPrice: "101170", off: "40" },
  ];

  const formatWithCommas = (number) => {
    const numStr = number.toString();
    
    // If the number has less than four digits, return it as is.
    if (numStr.length <= 3) return numStr;
    
    // Split the string into two parts: last three digits and the rest
    const lastThree = numStr.slice(-3);
    const rest = numStr.slice(0, -3);
    
    // Format the "rest" part to insert commas every two digits
    const formattedRest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    
    // Combine both parts with a comma between them
    return `${formattedRest},${lastThree}`;
  };  

  // Toggle switch function
  const handleToggle = (option) => {
    if ((option === 'monthly' && isMonthly) || (option === 'yearly' && !isMonthly)) {
      return; // Avoid toggling if the selected option is already active
    }
    setFade(true); // Trigger fade-out effect
    setTimeout(() => {
      setIsMonthly(option === 'monthly');
      setFade(false); // Remove fade-out effect after toggling
    }, 200);
  };

  return (
    <>
      <div className="section-6">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="h1">Choose Your Perfect Plan</div>
          <div className="fs-6 mb-5 col-lg-4 col-12 text-center">Tailored Solutions for Every Business – Flexible Monthly and Yearly Options</div>
          <div className="mb-lg-5 mb-3 fs-6">
            <ul className="nav nav-pills nav-fill gap-2 p-1 small rounded-5 shadow-sm" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${isMonthly ? "active" : ""} rounded-5`}
                  onClick={() => handleToggle('monthly')}
                  type="button" role="tab"
                  aria-selected={isMonthly}
                >Monthly
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${!isMonthly ? "active" : ""} rounded-5`}
                  onClick={() => handleToggle('yearly')}
                  type="button" role="tab"
                  aria-selected={!isMonthly}
                >Yearly
                </button>
              </li>
            </ul>  
          </div>        
          <div className="col-12">
            <div className="d-flex flex-lg-row flex-column 
              justify-content-center align-items-center gap-lg-3 gap-0">
              {plans.map((plan, index) => (
                <div key={index} className="px-lg-4 px-4 py-lg-0 py-3">
                  <div className="card text-center p-4 rounded-4 shadow-sm bg-white"
                    style={{height: isMonthly ? "200px" : "250px"}}>
                    <h3 className="plan-name mb-3 fs-2 fw-bold">{plan.name}</h3>
                    <div className="d-flex justify-content-center align-items-center">
                      <span className="fs-3 pe-1">₹</span>
                      <span className={`discounted-price fs-lg-1 fs-2 fw-bold price ${fade ? "fade" : "fade-active"}`}>
                        {isMonthly ? 
                          formatWithCommas(plan.monthlyPrice) : 
                          formatWithCommas(parseInt(plan.monthlyPrice * 12 - plan.monthlyPrice * 12 * plan.off / 100))
                        }
                      </span>         
                    </div>
                    <div className={`fs-6 ${fade ? "fade" : "fade-active"}`}>
                      {isMonthly? 'per month' : 'per year'}
                    </div>
                    {!isMonthly && (
                      <div className="discount-section my-2">
                        <span className="discount-percent">{plan.off}% off</span>
                        <span className="ms-2 text-muted text-decoration-line-through fs-6">
                          &nbsp;₹{formatWithCommas(parseInt(plan.monthlyPrice) * 12)}&nbsp;
                        </span>
                      </div>
                    )}
                    {/* <div className="btn-area mt-3">
                      <button className="btn btn-primary rounded-3 px-4 py-2">Get Started</button>
                    </div> */}
                  </div>
                </div>
              ))}
              <div className="px-lg-4 px-4 py-lg-0 py-3">
                <div className="card text-center p-4 rounded-4 shadow-sm bg-white"
                  style={{height: isMonthly ? "200px" : "250px"}}>
                  <h3 className="plan-name mb-3 fs-2 fw-bold">Enterprise</h3>
                  <div style={{height: "50px"}}/>
                  <a href="tel:+918274945139" className="btn btn-primary rounded-3 py-2 w-100">
                    Contact Sales  
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
